import React, {useEffect, useState} from 'react';
import {Button, Card, Modal, Table} from "antd";
import {t} from "i18next";
import {useLazyGetApiMailTemplatesQuery} from "../../api/services/MailTemplates";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../app/store";
import {setError, setLoading} from "../../features/app/appSlice";
import moment from "moment/moment";
import TemplateEditor from "./TemplateEditor";

export interface INudgingEmails {

}

const NudgingEmails: React.FC<INudgingEmails> = ({}) => {
    const [fetchMailTemplateTypes, {data: templates}] = useLazyGetApiMailTemplatesQuery()
    const dispatch = useDispatch()
    const user = useSelector((state: RootState) => state.auth?.user);
    const [selectedTemplate, setSelectedTemplate] = useState<any>(undefined)

    useEffect(() => {
        if (user)
            getMailTemplateTypes()
    }, [user]);

    const getMailTemplateTypes = async () => {
        try {
            dispatch(setLoading(true));
            await fetchMailTemplateTypes({
                companyId: user?.companyId ?? ""
            })
        } catch (err: any) {
            if (err.status != "PARSING_ERROR")
                dispatch(setError(t('Mail tipleri sorgulanırken hata oluştu')));
        } finally {
            dispatch(setLoading(false));
        }
    }

    const columns = [

        {
            title: "E Posta Teması", dataIndex: 'name', key: 'name',
            render: (_: any, record: any) => {
                return (
                    <div className={"flex flex-row"}>
                        <span className={"font-semibold mr-2"}>{record.name}</span><span
                        className={"font-light"}>({record.desc})</span>
                    </div>
                )
            }
        }
    ];

    const handleCancel = () => {
        setSelectedTemplate(undefined);
    };

    return (<>
        <Table
            dataSource={(templates as any[]) ?? []}
            columns={columns}
            rowKey="id"
            rowHoverable={true}
            pagination={false}
            onRow={(record) => {
                return {
                    onClick: () => {
                        setSelectedTemplate(record)
                    }
                };
            }}
        />
        <Modal
            title={<div className={"flex flex-row"}>
                <span className={"font-semibold mr-2"}>{selectedTemplate?.name}</span><span
                className={"font-light"}>({selectedTemplate?.desc})</span>
            </div>}
            width={1200}
            onCancel={handleCancel}
            onClose={handleCancel}
            closable={true}
            maskClosable={false}
            destroyOnClose={true}
            open={selectedTemplate != undefined}
            footer={null}
        >
            {selectedTemplate &&
                <>
                    <TemplateEditor template={selectedTemplate}
                                    cancel={handleCancel}
                                    refresh={() => {
                                        getMailTemplateTypes()
                                        setSelectedTemplate(undefined);
                                    }}/>
                </>
            }
        </Modal>
    </>)
};

export default NudgingEmails;